import { CostCenter } from './../entities/costCenter';
import { Injectable, Injector } from '@angular/core';
import { PayStub } from '../entities/pay-stub';
import { Subject, Observable } from 'rxjs/Rx';
import { tap, map } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BaseService } from '../../shared/_utils/services/base-service';
import * as FileSaver from 'file-saver';
import { catchError } from 'rxjs/operators';

@Injectable()
export class PayStubService extends BaseService {

  private url =  this.rutaServidor + '/api/payStub';

  constructor(injector: Injector, private http: HttpClient) { super(injector); }

  getPayStub() {
    return this.http.get<PayStub[]>(`${this.url}/getListPayStub`);
  }

  searchPayStub(costCenter: any,
    employeeType: any, executingUnit: any,
    fiscalYear: any, month: any,
    payrollType: any, employee: any): Observable<PayStub[]> {
    const params = new HttpParams()
      .set('costCenter', costCenter)
      .set('employeeType', employeeType)
      .set('executingUnit', executingUnit)
      .set('fiscalYear', fiscalYear)
      .set('month', month)
      .set('payrollType', payrollType)
      .set('employee', employee);
      this.spinnerService.showAll();
    return this.http.get<PayStub[]>(`${this.url}/search`, {params})
     .pipe(
       tap(response => {
         this.spinnerService.hideAll();
         return response;
       })
    );
  }

  generateReport(employee: string,
    employeeType: string, executingUnit: string,
    fiscalYear: string, month: string,
    payrollType: string,costCenter: string,
    id : string, flgNotified:string,
    formatDatePipe: string,lang:string) {
    const params = new HttpParams()
      .set('employee', employee)
      .set('employeeType', employeeType)
      .set('executingUnit', executingUnit)
      .set('fiscalYear', fiscalYear) 
      .set('month', month)
      .set('payrollType', payrollType)
      .set('costCenter',costCenter)
      .set('id',id)
      .set('flgNotified',flgNotified)
      .set('formatDatePipe',formatDatePipe)
      .set('lang',lang)
      .set('name', 'paystub');
      this.spinnerService.showAll();
    return this.http.get(`${this.url}/report`,
      {
        params,
        responseType: 'blob',
      })
      .pipe(
        tap(response => {
         //console.log(response);
          this.spinnerService.hideAll();
          return response;
        })
      );
  }

  exportAllPayStub ( object: any ): Observable<Blob> {
    let ruta =  this.url   +  "/exportAllPayStub"; 
    let nameFile : "reportPayStub.pdf"; 
    this.spinnerService.showAll();
   // return this.http.get<PayStub[]>(`${this.url}/search`, {params})
    return this.httpClient.post(ruta,object, {responseType: 'blob' })
        .pipe( 
            map(res =>  { 
                this.spinnerService.hideAll();
                let bean = new Blob([res],{ type: 'application/pdf'});
                FileSaver.saveAs(bean, nameFile);
                return bean;
             }   ),
            catchError((err) => { 
                console.log("catchError : "  + catchError);
               this.spinnerService.hideAll();
               this.notificationService.serverErrorMessage(err.status +' - Ocurrió un error. Por favor, intentelo nuevamente más tarde. ');
               return new Observable<Blob>();
            })
             
            ) ;
      }
}



// WEBPACK FOOTER //
// ./src/app/core/services/pay-stub.service.ts